import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ClayPitBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.CLAY_PIT;
}

export default ClayPitBuildingTileEntity;
